import React, { useState } from "react";
import Button from "../../components/button/Button";
import styles from "./viewSharedData.module.scss";
import Select from "react-select";
import DownloadIcon from "../../assets/images/download.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  downloadSharedData,
  existingInputData,
  getProductInfo,
  sDActions,
  sdStates,
  // downloadJsonSharedData,
} from "./sharedDataSlice";
import { useNavigate } from "react-router-dom";
import Popup from "../../components/popUp/Popup";
import { handleDeleteSd } from "./sharedDataSlice";
import { selectUser } from "../../app/appSlice";
import { IoMdCloudUpload } from "react-icons/io";



const ViewShareddata = ({
  inputFields,
  currentSdState,
  availableSdStates,
  action,
  setSdState,
}) => {
  const existingInputs = useSelector(existingInputData);
  const productInfo = useSelector(getProductInfo);
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const state = availableSdStates.map((state) => {
    return { value: state, label: state };
  });
  const actions = [];
  // if (currentSdState === sdStates.draft) {
    if (currentSdState === sdStates) {

    actions.push(
      { value: sDActions.updateSharedData, label: sDActions.updateSharedData },
      { value: sDActions.deleteSharedData, label: sDActions.deleteSharedData }
    );
  } else {
    actions.push({
      value: sDActions.updateSharedData,
      label: sDActions.updateSharedData,
    });
  }
  // actions.push({
  //       value: sDActions.updateSharedData,
  //       label: sDActions.updateSharedData,
  //     });

  const customStyles = {
    control: (defaultStyles) => ({
      ...defaultStyles,
      fontFamily: "UniversLTStd-Light",
      width: "9.5rem",
      fontSize: "1rem",
      borderCollapse: "separate",
      height: "2.5rem",
      outline: "none",
      borderRadius: ".5rem",
      marginLeft: "0.5rem",
    }),
    indicatorSeparator: () => ({}),
  };

  const getRange = (name) => {
    const field = inputFields.find((item) => item.fieldName === name);
    return field.placeholderText
      ? `${field.placeholderText}${field.unit}`
      : "-";
  };

  const cleanDisplayValue = (value) => {
    if (typeof value === 'string') {
      return value.replace(/\u0000/g, '');
    }
    return value;
  };

  // Helper to get display value for Unit Model and Unit Serial
  const getDisplayValue = (item, existingInputs) => {
    if (typeof existingInputs['Unit Model'] === 'string') {
    const parts = existingInputs['Unit Model'].split('\u0000');
    const modelBeforeNull = parts[0];
    const modelAfterNull = parts.slice(1).join('');
      if (item.fieldName === 'Unit Model') {
        return modelBeforeNull;
      }
      if (item.fieldName === 'Unit Serial') {
        return cleanDisplayValue(modelAfterNull) + cleanDisplayValue(existingInputs['Unit Serial']);
      }
    }
    return cleanDisplayValue(existingInputs[item.fieldName]);
  };

  // const handleChange = (e) => {
  //   setSdState(e.value);
  // };

  const handleAction = (e) => {
    if (e.value === sDActions.updateSharedData) {
      navigate(`/products/update-shared-data?id=${productInfo.id}&actionId=${productInfo.ModelNumber}`);
    } else if (e.value === sDActions.deleteSharedData) {
      setShowPopup(true);
    }
  };

  const navigateToProduct = () => {
    navigate("/products");
  };

  return (
    <>
      <div className={styles.dropdownContainer}>
      {user?.roles?.includes('admin') && currentSdState !== sdStates.preProd &&( // Show only if user is an admin
        <Select
          placeholder="Actions"
          isSearchable={false}
          onChange={handleAction}
          options={actions}
          styles={customStyles}
          menuPosition={"fixed"}
          menuPortalTarget={document.body}
        />
      )}
        <Button
         onClick={async () => {
          if (currentSdState === sdStates.production || currentSdState === sdStates.staging || currentSdState === sdStates.preProd) {
           dispatch(downloadSharedData(currentSdState));
          }
        }}
        style={styles.download}            
        >
          <img src={DownloadIcon} alt="upload"></img>
          <span>Download</span>
        </Button>
        {/* <Button
          onClick={async () => {
            if (productInfo.CoolCloudDBAck === true)
              return;
            if (currentSdState === sdStates.production || currentSdState === sdStates.staging) {
              dispatch(downloadJsonSharedData(currentSdState))
                .catch((error) => {
                  console.error('Upload to CoolCloud failed:', error.message);
                })
            }
          }}
          style={(productInfo.CoolCloudDBAck !== true) ? styles.download : styles.downloadDisabled}
        > */}
          {/* <img src={DownloadIcon} alt="upload"></img>
           <IoMdCloudUpload style={{position: 'relative', top: '2px'}}/>
          <span> CoolCloud </span>
        </Button> */}
      </div>
      <div className={styles.viewContainer}>
        <table>
          <tbody>
            <tr className={styles.header}>
              <th className={styles.th}>Attributes</th>
              <th className={styles.th}>Range</th>
              <th className={styles.th}>Value</th>
            </tr>
            {inputFields.map((item) => {
              const displayValue = getDisplayValue(item, existingInputs);
              return (
                <tr key={item.fieldName} className={styles.sharedDataRow}>
                  <td className={styles.td}>{item.fieldName}</td>
                  <td className={styles.td}>{getRange(item.fieldName)}</td>
                  <td className={styles.td}>
                    {displayValue}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {showPopup && (
        <Popup
          title={
            <>
              Are you sure you want to{" "}
              <span className={styles.bold}>delete</span> this shared data?
            </>
          }
          description="Click 'Yes' to delete or 'Cancel' to go back."
          onSuccess={() => {
            setShowPopup(false);
            dispatch(handleDeleteSd({ navigateToProduct }));
          }}
          onCancel={() => {
            setShowPopup(false);
          }}
        />
      )}
    </>
  );
};

export default ViewShareddata;
